module.exports = __webpack_public_path__ + "img/banner03.cfd52efd.jpg";